module.exports = __webpack_public_path__ + "static/media/Arbeidsminne-Na-kommer-det-flere-ord.30634502.mp3";